<!-- <div class="initiative-filter-section">
    <mat-select class="initiative-filter-input" [(ngModel)]="business_plan" (selectionChange)="getInitiativesData()">
        <mat-option [value]="''" disabled>Select Busiess Plan</mat-option>
        <mat-option *ngFor="let business_plan of business_plan_list" [value]="business_plan.id">{{business_plan.name}}</mat-option>
    </mat-select>
</div> -->
<ng-container *ngIf="initiative_data_loaded">
  <div class="new-table-v2-section">
    <div class="new-table-v2-overflow">
      <table class="new-table-v2">
        <thead>
          <tr>
            <th appColumnResizable class="page-table-actions-cell">Actions</th>
            <th appColumnResizable class="page-table-actions-cell">Milestones</th>
            <th appColumnResizable class="page-table-actions-cell">Attachment</th>
            <th appColumnResizable>Initiative Name</th>
            <th appColumnResizable>Initiative Description</th>
            <th appColumnResizable>Initiative Owner</th>
            <th appColumnResizable>Initiative Objective</th>
            <th appColumnResizable>Initiative Budget</th>
            <th appColumnResizable>Initiative ROI</th>
            <th appColumnResizable>Initiative Category</th>
            <th appColumnResizable>Initiative Priority</th>
            <th appColumnResizable>Initiative Start Date</th>
            <th appColumnResizable>Initiative End Date</th>
            <th appColumnResizable>Initiative Status</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngIf="initiative_data_loaded && initiative_data.length > 0"
          >
            <ng-container
              *ngFor="
                let initiative of initiative_data
                  | paginate
                    : {
                        id: 'page-table-data',
                        itemsPerPage: 10,
                        currentPage: page_current_page,
                        totalItems: initiative_data.length
                      };
                let index = index
              "
            >
              <tr>
                <td class="page-table-actions-cell">
                  <ng-container
                    *ngIf="initiative.initiative_owner == user_details.id"
                  >
                    <img
                      src="assets/edit-client.png"
                      class="page-table-actions"
                      (click)="openInitiativeOperationsModal(initiative, index)"
                    />
                  </ng-container>
                  <ng-container
                    *ngIf="initiative.initiative_owner != user_details.id"
                  >
                    <span>-</span>
                  </ng-container>
                </td>
                <td style="padding-top: 0" class="page-table-actions-cell">
                  <img
                    src="assets/ic-activities.png"
                    class="page-table-actions"
                    (click)="toggleMileStonesView(index)"
                  />
                </td>
                <td class="page-table-actions-cell">
                  <ng-container
                    *ngIf="initiative.initiative_owner == user_details.id"
                  >
                    <i
                      class="fa fa-upload initiative-icons"
                      (click)="initiativeUpload.click()"
                    ></i>
                    <input
                      type="file"
                      #initiativeUpload
                      (change)="uploadInitiative($event, initiative, index)"
                      style="display: none"
                    />
                    <i
                      (click)="
                        downloadInitiativeAttachment(
                          initiative.initiative_attachment
                        )
                      "
                      *ngIf="
                        initiative.initiative_attachment != null &&
                        initiative.initiative_attachment != ''
                      "
                      class="fa fa-download initiative-icons"
                    ></i>
                  </ng-container>
                  <ng-container
                    *ngIf="initiative.initiative_owner != user_details.id"
                  >
                    <span>-</span>
                  </ng-container>
                </td>
                <td>{{ initiative.initiative_name }}</td>
                <!-- <td>{{initiative.initiative_description}}</td> -->
                <td [innerHTML]="initiative.initiative_description"></td>
                <td>{{ initiative.initiative_owner_short_name }}</td>
                <td>{{ initiative.initiative_objective }}</td>
                <td>{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ initiative.initiative_budget }}</td>
                <td>{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ initiative.initiative_roi }}</td>
                <td>{{ initiative.initiative_category_name }}</td>
                <td>{{ initiative.initiative_priority_name }}</td>
                <td>
                  {{ initiative.initiative_start_date | date: "dd MMM yyyy" }}
                </td>
                <td>
                  {{ initiative.initiative_end_date | date: "dd MMM yyyy" }}
                </td>
                <td>
                  <span
                    [ngClass]="{
                      'activity-status-pending':
                        initiative.initiative_status_name == 'Pending',
                      'activity-status-progress':
                        initiative.initiative_status_name == 'In Progress',
                      'activity-status-completed':
                        initiative.initiative_status_name == 'Completed'
                    }"
                    >{{ initiative.initiative_status_name }}</span
                  >
                </td>
              </tr>
              <tr *ngIf="show_mile_stones == index">
                <td colspan="14">
                  <app-initiative-milestones
                    [initiative_data]="initiative"
                    [filters_data]="filters_data"
                  ></app-initiative-milestones>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-container
            *ngIf="initiative_data_loaded && initiative_data.length == 0"
          >
            <tr>
              <td colspan="7">
                <div class="new-table-v2-zero-state">
                  <span>No Initiatives Found</span>
                </div>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!initiative_data_loaded">
            <tr>
              <td colspan="7">
                <app-loader
                  [loading_text]="'Loading Initiatives Data'"
                ></app-loader>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="new-table-v2-pagination-section">
      <span>{{ initiative_data.length | number:'1.0-0' }} Records</span>
      <div class="new-table-v2-pagination-controls">
        <pagination-controls
          id="page-table-data"
          (pageChange)="pageChanged($event)"
          style="text-align: right; position: relative; top: 6px"
        ></pagination-controls>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!initiative_data_loaded">
  <app-loader [loading_text]="'Loading Initiatives'"></app-loader>
</ng-container>

<ng-template #initiativeOperationsModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span>{{ initiative_operation_type }} Initiative Details</span>
      <span
        class="page-modal-close-icon"
        (click)="closeInitiativeOperationsModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Initiative ROI({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
        <input
          type="text"
          class="page-modal-input"
          [(ngModel)]="selected_initiative_data.initiative_roi"
          (keypress)="numberOnly($event)"
        />
        <p
          class="page-modal-input-error"
          *ngIf="selected_initiative_data_errors.initiative_roi"
        >
          Initiative ROI is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Initiative Status</p>
        <mat-select
          class="page-modal-input"
          [(ngModel)]="selected_initiative_data.initiative_status"
        >
          <mat-option [value]="''">Select Initiative Status</mat-option>
          <mat-option *ngFor="let status of status_list" [value]="status.id">{{
            status.name
          }}</mat-option>
        </mat-select>
        <p
          class="page-modal-input-error"
          *ngIf="selected_initiative_data_errors.initiative_status"
        >
          Initiative Status is Required.
        </p>
      </div>
    </div>
    <div class="page-modal-footer-section">
      <button class="page-modal-primary-button" (click)="saveInitiative()">
        Save
      </button>
      <button
        class="page-modal-secondary-button"
        (click)="closeInitiativeOperationsModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</ng-template>
